<template>
    <address-select-checkout
            @address-changed="addressChanged"
            address-type="2"
            :optional-address-fields="optionalAddressFields"
            :required-address-fields="requiredAddressFields"
            :default-salutation="defaultSalutation"
            :padding-classes="paddingClasses"
            :padding-inline-styles="paddingInlineStyles">
        <template #custom-address-fields>
            <slot name="custom-address-fields"></slot>
        </template>
    </address-select-checkout>
</template>

<script>
import {mapState} from "vuex";
import AddressSelectCheckout from "./AddressSelect.vue";

export default {

    components:
        {
            AddressSelectCheckout
        },

    props:
        {
            optionalAddressFields:
                {
                    type: Object,
                    default: () => {
                        return {};
                    }
                },
            requiredAddressFields:
                {
                    type: Object,
                    default: () => {
                        return {};
                    }
                },
            defaultSalutation:
                {
                    type: String,
                    default: "male"
                },
            paddingClasses:
                {
                    type: String,
                    default: null
                },
            paddingInlineStyles:
                {
                    type: String,
                    default: null
                }
        },

    computed: mapState({
        deliveryAddressId: state => state.address.deliveryAddressId
    }),

    methods:
        {
            /**
             * Update the delivery address
             * @param selectedAddress
             */
            addressChanged(selectedAddress) {
                this.$store.dispatch("selectAddress", {selectedAddress, addressType: "2"})
                    .then(
                        response => {
                            document.dispatchEvent(new CustomEvent("afterDeliveryAddressChanged", {detail: this.deliveryAddressId}));
                        },
                        error => {

                        }
                    );
            }
        }
};
</script>
